<ng-container *appTranslate="let t">
  <div class="w-overlay dialog-form">
    <p-message severity="info" variant="simple" size="small">
      {{ t("translationProposal.gatheringComponent.translationHint") }}
    </p-message>

    <div class="col">
      <p class="text-caption-text-regular">
        {{ t("translationProposal.gatheringComponent.existingTranslation") }}
      </p>

      <div class="border border-(--p-form-field-border-color) rounded-border">
        <p class="p-2">
          {{ textToCorrect }}
        </p>
      </div>
    </div>

    <new-ui-inputtext
      [label]="t('translationProposal.gatheringComponent.proposedTranslation')"
      [(ngModel)]="textCorrected"
      [badgeDisabled]="true"
    />

    <new-ui-inputtext
      [label]="t('translationProposal.gatheringComponent.reasonForProposal')"
      [(ngModel)]="reasonForCorrection"
      [badgeDisabled]="true"
    />

    <div class="col">
      <new-ui-button
        [fluid]="true"
        [label]="t('common.save')"
        icon="icon-[mi--checkmark-medium]"
        [disabled]="textCorrected == '' || textCorrected == null || textCorrected == textToCorrect"
        (onClick)="submit($event)"
      />

      <new-ui-button
        [fluid]="true"
        [label]="t('common.cancel')"
        icon="icon-[mi--close-medium]"
        severity="secondary"
        (onClick)="cancel($event)"
      />
    </div>
  </div>
</ng-container>
